import { Address } from 'viem'
import { ChainId } from '@/shared/config/chain.ts'
import { getIconPath } from '@/shared/lib/utils/asset.ts'
import { EMPTY_ADDRESS } from '@/shared/constants/address.ts'
import { normalizeAddress } from '@/shared/lib/utils/format.ts'

export type TokenTicker = 'KAIA' | 'stKAIA' | 'rstKAIA' | 'sKlay' | 'gcKlay' | 'wGCKlay' | 'stKLAY' | 'LAIR' | 'Lr' | 'LrBGT' | 'BERA' | 'iBGT'

export const TokenTickers: Record<TokenTicker, TokenTicker> = {
  KAIA: 'KAIA',
  stKAIA: 'stKAIA',
  rstKAIA: 'rstKAIA',
  sKlay: 'sKlay',
  wGCKlay: 'wGCKlay',
  gcKlay: 'gcKlay',
  stKLAY: 'stKLAY',
  LAIR: 'LAIR',
  Lr: 'Lr',
  LrBGT: 'LrBGT',
  BERA: 'BERA',
  iBGT: 'iBGT',
} as const

export const TokenImages: Record<TokenTicker, string> = {
  KAIA: getIconPath('kaia.png', 'token'),
  stKAIA: getIconPath('stkaia.png', 'token'),
  rstKAIA: getIconPath('rstkaia.png', 'token'),
  sKlay: getIconPath('sklay.png', 'token'),
  wGCKlay: getIconPath('wgcklay.png', 'token'),
  gcKlay: getIconPath('gcklay.png', 'token'),
  stKLAY: getIconPath('stklay.png', 'token'),
  LAIR: getIconPath('lair.png', 'token'),
  Lr: getIconPath('lair.png', 'token'),
  LrBGT: getIconPath('lrbgt.png', 'token'),
  BERA: getIconPath('bera.png', 'token'),
  iBGT: getIconPath('ibgt.png', 'token'),
} as const

export const TokenAddresses: Record<ChainId, Record<TokenTicker, Address>> = {
  [ChainId.KAIA]: {
    KAIA: normalizeAddress(EMPTY_ADDRESS),
    stKAIA: normalizeAddress('0x42952B873ed6f7f0A7E4992E2a9818E3A9001995'),
    rstKAIA: normalizeAddress('0xd05fCB2d4c427232C3b36a33E21a4F23810A298F'),
    sKlay: normalizeAddress('0xa323d7386b671e8799dca3582d6658fdcdcd940a'),
    wGCKlay: normalizeAddress('0x9b58b9d82b47b9e9fdf76460b8e65df154664cfe'),
    gcKlay: normalizeAddress('0x999999999939Ba65AbB254339eEc0b2A0daC80E9'),
    stKLAY: normalizeAddress('0xF80F2b22932fCEC6189b9153aA18662b15CC9C00'),
    LAIR: normalizeAddress('0xD70C7D511560493C79DF607076fB863f5c8A50b0'),
    Lr: normalizeAddress(EMPTY_ADDRESS),
    LrBGT: normalizeAddress(EMPTY_ADDRESS),
    BERA: normalizeAddress(EMPTY_ADDRESS),
    iBGT: normalizeAddress(EMPTY_ADDRESS),
  },
  [ChainId.KAIA_TESTNET]: {
    KAIA: normalizeAddress(EMPTY_ADDRESS),
    stKAIA: normalizeAddress('0xe6c96a881383827575db257639736ea0b55ea68d'),
    rstKAIA: normalizeAddress('0xB35a1f39aD1ae7140BFA9E3806Bf9AD18E8f1E0b'),
    sKlay: normalizeAddress(EMPTY_ADDRESS),
    wGCKlay: normalizeAddress(EMPTY_ADDRESS),
    gcKlay: normalizeAddress(EMPTY_ADDRESS),
    stKLAY: normalizeAddress(EMPTY_ADDRESS),
    LAIR: normalizeAddress('0xca5E77CC3b50D26dD8f13F32e97F0695fCc46a46'),
    Lr: normalizeAddress(EMPTY_ADDRESS),
    LrBGT: normalizeAddress(EMPTY_ADDRESS),
    BERA: normalizeAddress(EMPTY_ADDRESS),
    iBGT: normalizeAddress(EMPTY_ADDRESS),
  },
  [ChainId.BERA]: {
    KAIA: normalizeAddress(EMPTY_ADDRESS),
    stKAIA: normalizeAddress(EMPTY_ADDRESS),
    rstKAIA: normalizeAddress(EMPTY_ADDRESS),
    sKlay: normalizeAddress(EMPTY_ADDRESS),
    wGCKlay: normalizeAddress(EMPTY_ADDRESS),
    gcKlay: normalizeAddress(EMPTY_ADDRESS),
    stKLAY: normalizeAddress(EMPTY_ADDRESS),
    LAIR: normalizeAddress('0xf3530788DEB3d21E8fA2c3CBBF93317FB38a0D3C'),
    Lr: normalizeAddress(EMPTY_ADDRESS),
    LrBGT: normalizeAddress(EMPTY_ADDRESS),
    BERA: normalizeAddress(EMPTY_ADDRESS),
    iBGT: normalizeAddress(EMPTY_ADDRESS),
  },
} as const

export const LiquidTokenTickers: TokenTicker[] = [
  TokenTickers.stKAIA,
  TokenTickers.sKlay,
  TokenTickers.wGCKlay,
  TokenTickers.gcKlay,
  TokenTickers.stKLAY,
] as const

export const LiquidTokenDescriptions: Partial<Record<TokenTicker, string>> = {
  stKAIA: 'Lair Staked KAIA',
  rstKAIA: 'Lair Restaked KAIA',
  sKlay: 'KLAYstation Staked KAIA',
  gcKlay: 'Swapscanner Staked KAIA',
  stKLAY: 'Stake.ly Staked KAIA',
} as const

export const NativeTokenTickers: Record<ChainId, TokenTicker> = {
  [ChainId.KAIA]: TokenTickers.KAIA,
  [ChainId.KAIA_TESTNET]: TokenTickers.KAIA,
  [ChainId.BERA]: TokenTickers.BERA,
  [ChainId.BERA_TESTNET]: TokenTickers.BERA,
} as const
